import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PhoneBarContextType {
  isVisible: boolean;
  setIsVisible: (visible: boolean) => void;
  phoneNumber: string;
  setPhoneNumber: (phone: string) => void;
}

const PhoneBarContext = createContext<PhoneBarContextType | undefined>(undefined);

export const usePhoneBar = () => {
  const context = useContext(PhoneBarContext);
  if (context === undefined) {
    throw new Error('usePhoneBar must be used within a PhoneBarProvider');
  }
  return context;
};

interface PhoneBarProviderProps {
  children: ReactNode;
}

export const PhoneBarProvider: React.FC<PhoneBarProviderProps> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('+16317107600');

  return (
    <PhoneBarContext.Provider value={{ isVisible, setIsVisible, phoneNumber, setPhoneNumber }}>
      {children}
    </PhoneBarContext.Provider>
  );
};